import { render, staticRenderFns } from "./grossing-touch-case-sidepanel.vue?vue&type=template&id=196f780e&"
import script from "./grossing-touch-case-sidepanel.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-case-sidepanel.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports